function ReferralVO(id, dateOfIssue, type, clinic, patient, name, target, examinationType, cito, unitName, address,
                    previousExaminations, deadline, visitCard, payer, diagnosis, procedures, laboratoryTests, alabOffers,
                    alabResource, attachment, diagnosticExamination, alreadyPrinted, external) {

    this.id = id;
    this.dateOfIssue = dateOfIssue;
    this.type = type;
    this.clinic = clinic;
    this.patient = patient;
    this.name = name;
    this.target = target;
    this.examinationType = examinationType;
    this.unitName = unitName;
    this.address = address;
    this.previousExaminations = previousExaminations;
    this.cito = cito;
    this.deadline = deadline;
    this.visitCard = visitCard;
    this.payer = payer;
    this.diagnosis = diagnosis;
    this.procedures = procedures;
    this.laboratoryTests = laboratoryTests;
    this.alabOffers = alabOffers;
    this.alabResource = alabResource;
    this.diagnosticExamination = diagnosticExamination;
    this.alreadyPrinted = alreadyPrinted;
    this.external = external;


    var _typeContext = {
        dateOfIssue: Date,
        clinic: ClinicVO,
        patient: PatientVO,
        deadline: Date,
        visitCard: VisitCardVO,
        payer: DictionaryElementVO,
        diagnosis: DictionaryElementVO,
        procedures: DictionaryElementVO,
        laboratoryTests: DictionaryElementVO,
        alabOffers: ALABOfferVO,
        alabResource: MeedyOfficeWrapper,
        attachment: AttachmentVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
